import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import DashboardPage from "layouts/DashboardPage/DashboardPage";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import GlobalLoader from "components/GlobalLoader/GlobalLoader";
import MDAlert from "components/MDAlert";
import WorkOrderForm from "components/fleet/WorkOrderForm";
import useGetDailyFormWorkOrder from "hooks/fleet/useGetDailyFormWorkOrder";
import useUpdateDailyFormWorkOrder from "hooks/fleet/useUpdateDailyFormWorkOrder";
import parseGraphQLError from "utils/graphQL/parseGraphQLError";
import { UpdateWorkOrderInput } from "DDD/action-objects/WorkOrderEdit";

export default function EditWorkOrderPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data: workOrder, loading, error } = useGetDailyFormWorkOrder({ id: id });
  const [updateWorkOrder, { loading: updating }] = useUpdateDailyFormWorkOrder();

  const handleSubmit = async (data: UpdateWorkOrderInput) => {
    const result = await updateWorkOrder({
      variables: {
        input: {
          id: data.id,
          issueName: data.issueName,
          issueDescription: data.issueDescription,
          issueType: data.issueType,
          comments: data.comments,
          priority: data.priority,
          status: data.status as any,
          neededCompletionDate: data.neededCompletionDate || null,
          currentMeterReading: data.currentMeterReading ?? null,
          estimatedTaskTime: data.estimatedTaskTime ?? null,
          vehicleId: data.vehicleId,
          assignedTo: data.assignedTo || null,
          servicePlanId: data.servicePlanId || null,
          files: (data.files || []).filter((file): file is { name: string; path: string } =>
            Boolean(file?.name && file?.path)
          ),
          ...(data.removeFiles &&
            data.removeFiles.length > 0 && {
              removeFiles: data.removeFiles,
            }),
        } as any,
      },
    });

    if (result.data?.updateDailyFormWorkOrder) {
      navigate("/fleet/work-orders");
    }
  };

  if (loading) {
    return <GlobalLoader />;
  }

  if (!workOrder) {
    return (
      <DashboardPage>
        <MDAlert color="error">Work order not found</MDAlert>
      </DashboardPage>
    );
  }

  return (
    <DashboardPage>
      <MDBox mb={3}>
        <MDTypography variant="h4" fontWeight="medium">
          Edit Work Order
        </MDTypography>
      </MDBox>
      <WorkOrderForm workOrder={workOrder} onSubmit={handleSubmit} loading={updating} />
    </DashboardPage>
  );
}
